import { OWNERS, OWNER_ORDER, allTasks, statusOf, toggledStatus, canEditTask } from "./util";

export default function WorkplanOwner({ nodes, isAdmin, onStatus }) {
  const tasks = allTasks(nodes);
  return (
    <div className="wp-owner-view" data-testid="wp-owner">
      {OWNER_ORDER.map((owner) => {
        const mine = tasks.filter((t) => t.owner === owner);
        if (!mine.length) return null;
        const done = mine.filter((t) => statusOf(t) === "done").length;
        return (
          <div className="wp-lane" key={owner} data-testid={`wp-lane-${owner}`}>
            <div className="wp-lane-head">
              <span className={`wp-owner o-${owner}`}>{OWNERS[owner]}</span>
              <span className="wp-lane-count">
                {done}/{mine.length} done
              </span>
            </div>
            <div className="wp-lane-cards">
              {mine.map((t) => {
                const can = canEditTask(t, isAdmin);
                return (
                  <span
                    key={t.id}
                    className={`wp-chip ${statusOf(t) === "done" ? "done" : ""} ${statusOf(t) === "doing" ? "doing" : ""}`}
                    onClick={() => can && onStatus(t.id, toggledStatus(t))}
                    style={!can ? { cursor: "default" } : {}}
                    title={t.title}
                    data-testid={`wp-chip-${t.id}`}
                  >
                    {t.title}
                  </span>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
